import { useCallback, useState } from 'react';

/**
 * Управление одним открытым элементом аккордеона (по индексу).
 * При клике на другой элемент — закрывает текущий и открывает новый.
 */
export function useAccordion(initialOpenIndex: number | null = 0): {
  openIndex: number | null;
  toggle: (index: number) => void;
  isOpen: (index: number) => boolean;
} {
  const [openIndex, setOpenIndex] = useState<number | null>(initialOpenIndex);

  const toggle = useCallback((index: number) => {
    setOpenIndex(prev => (prev === index ? null : index));
  }, []);

  const isOpen = useCallback((index: number) => openIndex === index, [openIndex]);

  return { openIndex, toggle, isOpen };
}

/**
 * Управление аккордеоном: при клике закрываются все остальные, открывается только выбранный.
 * Если клик по уже открытому — закрывается (одно открытое или ни одного).
 */
export function useAccordionSingle(initialOpenIndex: number | null = 0): {
  openIndex: number | null;
  toggle: (index: number) => void;
  isOpen: (index: number) => boolean;
} {
  return useAccordion(initialOpenIndex);
}
